import { Phone } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function Hero() {
  const [showSecondImage, setShowSecondImage] = useState(false);

  useEffect(() => {
    // Toggle between images every 12 seconds
    const interval = setInterval(() => {
      setShowSecondImage(prev => !prev);
    }, 12000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <div className="relative w-full h-full overflow-hidden">
          {/* Landscape photo (LCP) */}
          <picture className={`absolute w-full h-full transition-opacity duration-1000 ${
            showSecondImage ? 'opacity-0' : 'opacity-100'
          }`}>
            <source
              srcSet="/images/a-serene-landscape-photo-with-majestic-mountains-optimized.webp"
              type="image/webp"
            />
            <img
              src="/images/a-serene-landscape-photo-with-majestic-mountains-optimized.webp"
              alt="Serene landscape with majestic mountains"
              width={1920}
              height={1080}
              fetchPriority="high"
              decoding="async"
              className="w-full h-full object-cover animate-kenburns"
            />
          </picture>

          {/* Waterfall photo */}
          <picture className={`absolute w-full h-full transition-opacity duration-1000 ${
            showSecondImage ? 'opacity-100' : 'opacity-0'
          }`}>
            <source
              srcSet="/images/a-serene-photo-of-a-cascading-waterfall-optimized.webp"
              type="image/webp"
            />
            <img
              src="/images/a-serene-photo-of-a-cascading-waterfall-optimized.webp"
              alt="Serene cascading waterfall"
              width={1920}
              height={1080}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover animate-kenburns"
            />
          </picture>
          
          <div className="absolute inset-0 bg-brand-teal-dark/30"></div>
        </div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Experienced ICBC Accident Counselling Services in Surrey.
          </h1>
          <p className="text-xl text-white mb-8">
            Professional Private Counsellors with over 15 years experience.
            Free 15 minutes initial consultation. <a href="/icbc-coverage-and-other-coverage" title="Learn about ICBC direct billing and how to get 12 free recovery sessions">ICBC Direct Billing</a>

          </p>
          <div className="flex flex-col items-center">
            <p className="text-xl text-white mb-4">
              Call us today to book your consultation
            </p>
            <a
              href="tel:604-619-9992"
              className="inline-flex items-center justify-center px-8 py-4 bg-brand-teal hover:bg-brand-teal-dark text-white font-medium rounded-lg transition-colors text-xl"
            >
              <Phone className="mr-2 h-5 w-5" />
              604-619-9992
            </a>
            <div className="mt-8">
              <picture>
                <source
                  srcSet="/images/certifications/kristinasohalrcc-metrocounselling-surrey.webp"
                  type="image/webp"
                />
                <img
                  src="/images/certifications/kristinasohalrcc-metrocounselling-surrey.webp"
                  alt="Rated Top Counsellor Surrey - Best Business of 2026 - Kristina Sohal, RCC - Metro Counselling"
                  width={256}
                  height={256}
                  fetchPriority="high"
                  decoding="async"
                  className="w-64 h-64 object-contain"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}